import React from 'react';
import TimelineCareDetails from './TimelineCareDetails';
import {
  buildDraftsFromSuggestions,
  groupDraftsByKnowledgeType,
} from './careKnowledgeSuggestionReviewModel';
import { splitReviewableCareKnowledgeSuggestions } from './careSourceReviewableCandidates';

const TimelineEntryCareDetails = ({ entry = {} }) => {
  const suggestions = React.useMemo(() => (
    splitReviewableCareKnowledgeSuggestions({
      suggestedCareKnowledgeItems: Array.isArray(entry.metadata?.careDetails)
        ? entry.metadata.careDetails
        : [],
    }).generic.map((suggestion) => {
      const original = entry.metadata.careDetails.find((item, index) => (
        String(item.clientId || item.id || `knowledge-${index + 1}`).trim() === suggestion.clientId
      ));
      return { ...suggestion, durability: original?.durability, promotionDecision: original?.promotionDecision };
    })
  ), [entry.metadata?.careDetails]);
  const groupedDrafts = React.useMemo(() => (
    groupDraftsByKnowledgeType(buildDraftsFromSuggestions(suggestions))
  ), [suggestions]);

  if (!suggestions.length) return null;

  return (
    <TimelineCareDetails
      detailCount={suggestions.length}
      groupedDrafts={groupedDrafts}
    />
  );
};

export default TimelineEntryCareDetails;
